export default __webpack_public_path__ + "static/data-vis-page-analytics-light-593512c4c0e318cd695f022b00881540b186fda4e94e86afe6617ccaa858f5bf.png";